import { Injectable, signal } from '@angular/core';
import { MatchmakingTranslationsKeys, OptionItem } from 'matchmaking/models';

@Injectable({
    providedIn: 'root'
})
export class MatchmakingTranslateService {
    translations = signal<MatchmakingTranslationsKeys | null>(null);

    // Manual string comparison in the translations object - it looks for a matching key and returns its value
    getTranslation(key: string): string | null {
        const translations = this.translations();
        if (translations) {
            for (const group of Object.keys(this.translations()!)) {
                const keys = translations[group as keyof typeof translations];
                if (Object.hasOwn(keys, key)) {
                    return String(keys[key as keyof typeof keys]);
                }
            }
        }

        return null;
    }
}
